import { useState, useEffect } from 'react'

import { DatePickerInput } from '@mantine/dates';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar'
import { get_plans } from '../../utils/apis/plans'
import { Modal, Button, Input, Textarea, Flex, Text, Select, Tabs, Box } from '@mantine/core';
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useCustomer } from '../../store/useCustomer';
import { HiOutlineUser, HiOutlineClipboardList, HiOutlineMap } from 'react-icons/hi';
dayjs.extend(calendar)


const ModalCustomers = ({ onClose, isOpen, item }) =>
{
  const { postNewCustomer, updateCustomer } = useCustomer();
  const [ plans, setPlans ] = useState([]);

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: Yup.object(validationSchema()),
    onSubmit: async (values) =>
    {
      const data = { ...values };
      data.start_from = dayjs(data.start_from).toISOString();
      data.date_billing = dayjs(data.date_billing).toISOString();
      if (data.limit_date_billing) data.limit_date_billing = dayjs(data.limit_date_billing).toISOString();
      data.limit_payday = Number(data.limit_payday);

      if (!data.ip_address || data.ip_address === '') {
        delete data.ip_address;
      }

      try {
        if (item === null) {
          await postNewCustomer(data);
          formik.resetForm()
        } else {
          data._id = item._id;
          await updateCustomer(data)
          formik.resetForm()
        }
        onClose()
      } catch (error) {
        console.log(error)
      }
    }
  })

  const close = () =>
  {
    formik.resetForm()
    onClose()
  }

  const listPlans = async () =>
  {
    const response = await get_plans()
    setPlans(response)
  }

  const changeDate = (date) =>
  {
    formik.setFieldValue('start_from', date)
    const anchorDay = dayjs(date).date();
    let facturacion = dayjs(date).add(1, 'month');
    const daysInMonth = facturacion.daysInMonth();
    facturacion = facturacion.date(Math.min(anchorDay, daysInMonth)).toDate();
    formik.setFieldValue('date_billing', facturacion)
  }

  const changeTypeContract = (typeContract) =>
  {
    formik.setFieldValue('type_contract', typeContract)
    if (typeContract === 'Postpago') {
      formik.setFieldValue('limit_payday', 10);
      formik.setFieldValue('limit_date_billing', dayjs().add(1, 'M').add(10, 'day').toDate());
    }
    if (typeContract === 'Prepago') {
      formik.setFieldValue('limit_payday', 0);
      formik.setFieldValue('limit_date_billing', dayjs().add(1, 'M').add(0, 'day').toDate());
    }
  }


  useEffect(() =>
  {
    listPlans()
    if (item) {
      formik.setFieldValue('num_account', item.num_account);
      formik.setFieldValue('full_name', item.full_name);
      formik.setFieldValue('email', item.email);
      formik.setFieldValue('phone', item.phone);
      formik.setFieldValue('cellphone', item.cellphone);
      formik.setFieldValue('latitude', item.latitude);
      formik.setFieldValue('longitude', item.longitude);
      formik.setFieldValue('address', item.address);
      formik.setFieldValue('id_type_plan', item.id_type_plan);
      formik.setFieldValue('type_contract', item.type_contract);
      formik.setFieldValue('limit_date_billing', item.limit_date_billing ? dayjs(item.limit_date_billing).toDate() : null);
      formik.setFieldValue('limit_payday', item.limit_payday);
      formik.setFieldValue('payment_reference', item.payment_reference);
      formik.setFieldValue('ip_address', item.ip_address || '');
      let start = dayjs(item.start_from).toDate();
      let billing = dayjs(item.date_billing).toDate();
      formik.setFieldValue('start_from', start);
      formik.setFieldValue('date_billing', billing);
    } else {
      const today = dayjs();
      formik.setFieldValue('start_from', today.toDate());
      const anchorDay = today.date();
      let nextMonth = today.add(1, 'month');
      const daysInMonth = nextMonth.daysInMonth();
      nextMonth = nextMonth.date(Math.min(anchorDay, daysInMonth));
      formik.setFieldValue('date_billing', nextMonth.toDate());
    }

  }, [ item, isOpen ])

  return (
    <>
      <Modal size="lg" opened={ isOpen } onClose={ close } title={ !item?._id ? 'Agregar Cliente' : 'Editar Cliente' } centered radius="lg">
        <Tabs color="yellow" defaultValue="account">
          <Tabs.List grow mb="md">
            <Tabs.Tab value="account" leftSection={<HiOutlineUser />}>Cuenta</Tabs.Tab>
            <Tabs.Tab value="plan" leftSection={<HiOutlineClipboardList />}>Plan</Tabs.Tab>
            <Tabs.Tab value="address" leftSection={<HiOutlineMap />}>Ubicación</Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="account">
            <Flex direction="column" gap="md" p="xs">
              <Flex gap="md">
                <Input.Wrapper label="# Cuenta" w="100%">
                  <Input
                    variant="filled"
                    size="md"
                    placeholder="# Cuenta"
                    value={ formik.values.num_account }
                    onChange={ formik.handleChange("num_account") }
                  />
                  { formik.touched.num_account && formik.errors.num_account && <Text c="red" fz="xs">{ formik.errors.num_account }</Text> }
                </Input.Wrapper>
                <Input.Wrapper label="Nombre" w="100%">
                  <Input
                    variant="filled"
                    size="md"
                    placeholder="Nombre completo"
                    value={ formik.values.full_name }
                    onChange={ formik.handleChange("full_name") }
                  />
                  { formik.touched.full_name && formik.errors.full_name && <Text c="red" fz="xs">{ formik.errors.full_name }</Text> }
                </Input.Wrapper>
              </Flex>
              
              <Box className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <Input.Wrapper label="Correo electrónico" w="100%">
                  <Input
                    variant="filled"
                    size="md"
                    placeholder="ejemplo@correo.com"
                    value={ formik.values.email }
                    onChange={ formik.handleChange("email") }
                  />
                  { formik.touched.email && formik.errors.email && <Text c="red" fz="xs">{ formik.errors.email }</Text> }
                </Input.Wrapper>

                <Input.Wrapper label="Dirección IP Asignada" w="100%">
                  <Input
                    variant="filled"
                    size="md"
                    placeholder="Ej: 192.168.1.100"
                    value={ formik.values.ip_address }
                    onChange={ formik.handleChange("ip_address") }
                  />
                  { formik.touched.ip_address && formik.errors.ip_address && <Text c="red" fz="xs">{ formik.errors.ip_address }</Text> }
                </Input.Wrapper>
              </Box>

              <Flex gap="md">
                <Input.Wrapper label="Teléfono fijo" w="100%">
                  <Input
                    variant="filled"
                    size="md"
                    placeholder="Teléfono fijo"
                    value={ formik.values.phone }
                    onChange={ formik.handleChange("phone") }
                  />
                  { formik.touched.phone && formik.errors.phone && <Text c="red" fz="xs">{ formik.errors.phone }</Text> }
                </Input.Wrapper>
                <Input.Wrapper label="Celular" w="100%">
                  <Input
                    variant="filled"
                    size="md"
                    placeholder="Celular"
                    value={ formik.values.cellphone }
                    onChange={ formik.handleChange("cellphone") }
                  />
                  { formik.touched.cellphone && formik.errors.cellphone && <Text c="red" fz="xs">{ formik.errors.cellphone }</Text> }
                </Input.Wrapper>
              </Flex>
            </Flex>
          </Tabs.Panel>

          <Tabs.Panel value="plan">
            <Flex direction="column" gap="md" p="xs">
              <Flex gap="md">
                <Input.Wrapper label="Plan contratado" w="100%">
                  <Select placeholder='Selecciona un plan'
                    variant="filled"
                    size="md"
                    value={ formik.values.id_type_plan }
                    data={ plans && plans.map(item => ({
                      value: item._id,
                      label: item.name,
                    })) }
                    onChange={ (value) => formik.setFieldValue("id_type_plan", value) }
                  />
                  { formik.touched.id_type_plan && formik.errors.id_type_plan && <Text c='red' fz={ 12 }>{ formik.errors.id_type_plan }</Text> }
                </Input.Wrapper>
                <Input.Wrapper label="Tipo de Contrato" w="100%">
                  <Select placeholder='Selecciona un tipo'
                    variant="filled"
                    size="md"
                    value={ formik.values.type_contract }
                    data={ [ "Prepago", "Postpago" ] }
                    onChange={ (e) => changeTypeContract(e) }
                  />
                  { formik.touched.type_contract && formik.errors.type_contract && <Text c='red' fz={ 12 }>{ formik.errors.type_contract }</Text> }
                </Input.Wrapper>
              </Flex>
              <Flex gap="md">
                <Input.Wrapper label="Fecha de inicio" w="100%">
                  <DatePickerInput value={ formik.values.start_from } valueFormat="YYYY-MM-DD" onChange={ changeDate } variant="filled"
                    size="md" />
                </Input.Wrapper>
                <Input.Wrapper label="Fecha de facturación" w="100%">
                  <DatePickerInput value={ formik.values.date_billing } disabled={ true } valueFormat="YYYY-MM-DD" variant="filled"
                    size="md" />
                </Input.Wrapper>
              </Flex>
              <Flex gap="md">
                <Input.Wrapper label="Días límite" w="100%">
                  <Input
                    variant="filled"
                    size="md"
                    disabled
                    placeholder="Días límite de pago"
                    value={ formik.values.limit_payday }
                  />
                </Input.Wrapper>
                <Input.Wrapper label="Fecha de corte" w="100%">
                  <DatePickerInput value={ formik.values.limit_date_billing } disabled={ true } valueFormat="YYYY-MM-DD" variant="filled"
                    size="md" />
                </Input.Wrapper>
              </Flex>
              <Input.Wrapper label="Referencia de pago" w="100%">
                <Input
                  variant="filled"
                  size="md"
                  placeholder="Referencia única de pago"
                  value={ formik.values.payment_reference }
                  onChange={ formik.handleChange("payment_reference") }
                />
                { formik.touched.payment_reference && formik.errors.payment_reference && <Text c="red" fz="xs">{ formik.errors.payment_reference }</Text> }
              </Input.Wrapper>
            </Flex>
          </Tabs.Panel>

          <Tabs.Panel value="address">
            <Flex direction="column" gap="md" p="xs">
              <Flex gap="md">
                <Input.Wrapper label="Latitud" w="100%">
                  <Input
                    variant="filled"
                    size="md"
                    placeholder="Ej: -34.6037"
                    value={ formik.values.latitude }
                    onChange={ formik.handleChange("latitude") }
                  />
                </Input.Wrapper>
                <Input.Wrapper label="Longitud" w="100%">
                  <Input
                    variant="filled"
                    size="md"
                    placeholder="Ej: -58.3816"
                    value={ formik.values.longitude }
                    onChange={ formik.handleChange("longitude") }
                  />
                </Input.Wrapper>
              </Flex>
              <Input.Wrapper label="Dirección completa" w="100%">
                <Textarea
                  variant="filled"
                  size="md"
                  minRows={3}
                  placeholder="Calle, número, localidad..."
                  value={ formik.values.address }
                  onChange={ formik.handleChange("address") }
                />
                { formik.touched.address && formik.errors.address && <Text c="red" fz="xs">{ formik.errors.address }</Text> }
              </Input.Wrapper>
            </Flex>
          </Tabs.Panel>
        </Tabs>

        <Flex justify="flex-end" gap="md" mt="xl">
          <Button variant="subtle" color='gray' onClick={ close }>
            Cancelar
          </Button>
          <Button onClick={ () => formik.handleSubmit() }>
            { !item?._id ? 'Crear Cliente' : 'Guardar Cambios' }
          </Button>
        </Flex>
      </Modal>
    </>
  )
}

export default ModalCustomers;

function initialValues ()
{
  return {
    num_account: '',
    full_name: '',
    email: '',
    phone: '',
    cellphone: '',
    latitude: '',
    longitude: '',
    address: '',
    id_type_plan: '',
    payment_reference: '',
    type_contract: '',
    start_from: '',
    limit_date_billing: '',
    date_billing: '',
    limit_payday: '',
    ip_address: ''
  }
}

function validationSchema ()
{
  const phoneRegExp = new RegExp('[0-9]{10}');
  const emailRegExp = /^[A-Z0-9.!#$%&'*+-/=?^_`{|}~]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  const ipRegExp = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

  return {
    num_account: Yup.string().required('El número de cuenta es requerido'),
    full_name: Yup.string().required('El nombre es requerido'),
    email: Yup.string().matches(emailRegExp, 'No parece ser un email válido'),
    phone: Yup.string().matches(phoneRegExp, 'El teléfono debe tener 10 dígitos'),
    cellphone: Yup.string().matches(phoneRegExp, 'El celular debe tener 10 dígitos'),
    latitude: Yup.string(),
    longitude: Yup.string(),
    address: Yup.string(),
    payment_reference: Yup.string(),
    id_type_plan: Yup.string().required('El plan es requerido'),
    type_contract: Yup.string().required('El tipo de contrato es requerido'),
    start_from: Yup.string().required('La fecha de inicio es requerida'),
    date_billing: Yup.string().required('La fecha de facturación es requerida'),
    limit_date_billing: Yup.string(),
    limit_payday: Yup.number().required('Días límite de pago requeridos'),
    ip_address: Yup.string().matches(ipRegExp, { message: 'No parece ser una dirección IP válida', excludeEmptyString: true }).nullable(),
  }
}
